// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2Sk59","subheader":"ReorderModal_subheader__r6zeQ","listWrap":"ReorderModal_listWrap__DTpZY"};